import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RideMetadataFieldOption extends AbstractModel {
  @autoserialize
  rideMetadataFieldId: number;

  @autoserialize
  value: string;

  @autoserialize
  active: boolean;
}
